import documentSignerAPI from '@/apis/eTask/documentSignerAPI.js';

export default {
  namespaced: true,
  state: () => ({
    /**
     * Danh sách popover
     */
    documentSigners: [],
  }),
  mutations: {
    /**
     * Xét danh sách người ký
     * @param {*} state 
     * @param {array} documentSigners Danh sách người ký
     * @author: BMThang(29/03/2023)
     */
    setDocumentSigners: (state, documentSigners) => {
      state.documentSigners = documentSigners
    },
  },
  actions: {
    /**
     * Lấy danh sách người ký
     * @author: BMThang(29/03/2023)
     */
    getDocumentSignerByOrganizationUnitID: async ({ commit, rootState }) => {
      try {
        const documentSigners = await documentSignerAPI.getDocumentSignersByOrganizationUnitID(rootState.context.User.OrganizationID);
        commit('setDocumentSigners', documentSigners)
      } catch {
        commit('setDocumentSigners', [])
      }
    },

    /**
     * Lưu danh sách người ký
     * @author: BMThang(29/03/2023)
     */
    saveDocumentSignerByOrganizationUnitID: async ({ commit, rootState, state }, documentSignerNames = []) => {
      console.log(documentSignerNames)
      if (!documentSignerNames.length) return;
      const formattedDocumentSigners = documentSignerNames.map(documentSignerName => ({ 
        DocumentSignerName: documentSignerName, 
        OrganizationUnitID: rootState.context.User.OrganizationID, 
      }))
      try {
        const newDocumentSigners = await documentSignerAPI.saveMultipleDocumentSigner(formattedDocumentSigners);
        const documentSigners = [...newDocumentSigners, ...state.documentSigners];
        commit('setDocumentSigners', documentSigners)
      } catch {
        commit('setDocumentSigners', state.documentSigners)
      }
    },

    /**
     * Lấy danh sách người ký
     * @author: BMThang(29/03/2023)
     */
    deleteDocumentSignerByID: async ({ commit, state }, deleteDocumentSignerID) => {
      try {
        const newDocumentSigners = state.documentSigners.filter(documentSigner => documentSigner.DocumentSignerID !== deleteDocumentSignerID);
        commit('setDocumentSigners', newDocumentSigners)
        await documentSignerAPI.deleteDocumentSignerByID(deleteDocumentSignerID);
      } catch {
        commit('setDocumentSigners', state.documentSigners)
      }
    },
  }
}